<template>
    <div class="modal fade" id="apply-job" tabindex="-1" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content" id="myModalLabel1">
                <div class="modal-header">
                    <h4 class="modal-title">申请职位</h4>
                </div>
                <div class="modal-body">
                    <!-- Tab panels -->
                    <div class="tab-content">
                        <!-- Employer Panel 1-->
                        <div class="tab-pane fade in show active" id="employer" role="tabpanel">
                            <div class="row mrg-bot-40 mrg-top-20" v-if="!isMagex && !config && !isExternal">
                                <div class="col-md-6 text-center">
                                    <a v-if="myResume" href="javascript:void(0)" class="btn theme-btn btn-m mrg-5" @click="applyJob" >使用已有简历{{ myResume.c_name || myResume.e_name }}应聘</a>
                                    <a v-else href="/portal/?desktop=true#/my-resume" class="btn theme-btn btn-m mrg-5" >填写新简历应聘</a>
                                </div>
                                <div class="col-md-6 text-center">
                                    <a href="/portal/?desktop=true#/my-resume" class="btn theme-btn-outlined btn-m mrg-5" target="_blank" v-if="myResume">在线修改简历</a>
                                </div>
                            </div>
                            <div class="row mrg-bot-20 mrg-top-10" v-else-if="config">
                                <div class="col-md-12 mrg-bot-10">
                                    <p>该职位由{{ config.feed_name }}提供，是否离开本站并前往应聘?</p>
                                </div>
                                <div class="col-md-6 text-center">
                                    <a href="javascript:void(0)" class="btn theme-btn btn-m mrg-5" @click="getGenericUrl">前往应聘</a>
                                </div>
                                <div class="col-md-6 text-center">
                                    <a href="javascript:void(0)" class="btn theme-btn-outlined btn-m mrg-5" @click="closeModal">暂不前往</a>
                                </div>
                            </div>
                            <div class="row mrg-bot-20 mrg-top-10" v-else-if="isMagex">
                                <div class="col-md-12 mrg-bot-10">
                                    <p>该职位由来自ACCA全球职位公告板，是否离开本站并前往应聘?</p>
                                </div>
                                <div class="col-md-6 text-center">
                                    <a href="javascript:void(0)" class="btn theme-btn btn-m mrg-5" @click="getMagexUrl">前往应聘</a>
                                </div>
                                <div class="col-md-6 text-center">
                                    <a href="javascript:void(0)" class="btn theme-btn-outlined btn-m mrg-5" @click="closeModal">暂不前往</a>
                                </div>
                            </div>
                            <div class="row mrg-bot-20 mrg-top-10" v-else-if="isExternal">
                                <div class="col-md-12 mrg-bot-10">
                                    <p>该职位只能通过外部站点申请，是否离开本站并前往应聘?</p>
                                </div>
                                <div class="col-md-6 text-center">
                                    <a href="javascript:void(0)" class="btn theme-btn btn-m mrg-5" @click="getExternalUrl">前往应聘</a>
                                </div>
                                <div class="col-md-6 text-center">
                                    <a href="javascript:void(0)" class="btn theme-btn-outlined btn-m mrg-5" @click="closeModal">暂不前往</a>
                                </div>
                            </div>                            
                            <div class="log-option mrg-bot-0 mrg-top-0" v-if="!isMagex && !config && !isExternal && email"><span>{{ $t('apply.or') }}</span></div>
                            
                            <div class="row mrg-bot-20" v-if="!isMagex && !config && !isExternal && email">
                                <div class="col-md-12">
                                    <h5>{{ $t('apply.e1') }}</h5>
                                    <p><a :href="'mailto:' + email">{{ email }}</a></p>
                                    <p>{{ $t('apply.e2') }} <a v-if="cvTemplateURL" :href="cvTemplateURL" target="_blank">简历模版下载</a></p>
                                </div>
                            </div>
                
                        </div>
                        <!--/.Panel 1-->
                    </div>
                    <!-- Tab panels -->
                </div>
            </div>
        </div>
    </div>  
</template>
<script>
/* global $ */

export default {
  name: 'ApplyModal',
  components: {
  },
  props: ['jobId', 'isMagex', 'config', 'email', 'isExternal'],
  data: () => ({
    wuyouUrl: null,
    magexUrl: null,
    genericUrl: null,
    externalUrl: null
  }),
  computed: {
    myResume: function() {
      return this.$store.state.myResume
    },
    url: function() {
      return this.SITE_URL + this.jobId
    },
    isHR: function() {
      return this.$router.currentRoute.name === 'join'
    },
    cvTemplateURL: function() {
      let siteOpts = this.$root.params && this.$root.params.site_opts
      return siteOpts && siteOpts.cv_template_url
    }
  },
  mounted: function() {
    this.wuyouUrl = null
    this.magexUrl = null
    this.genericUrl = null
    this.externalUrl = null
  },
  watch: {
    jobId: function() {
      this.wuyouUrl = null
      this.magexUrl = null
      this.genericUrl = null
      this.externalUrl = null
    }
  },
  methods: {
    applyJob: function() {
      let d = { 'vacancy_id': this.jobId, sourcing_channel: 'web_site'},
          that = this
      this.$http.post(this.API_PREFIX + '/api/vacancy_candidate', d).then(function () {
        that.$message({
          message: '应聘成功',
          type: 'success'
        })
      }).catch(function (error) {
        console.log(error)
        let msg = '出错了，请重试'
        if(error.response) {
            switch(error.response.status) {
              case 400:
                msg = '您已申请过该职位'
                break
            }
            that.$message({
              message: msg,
              type: 'error'
            })
        }
      })
      //close modal
      this.$nextTick (function () {
        $('#apply-job').modal('hide')
      })
    },
    closeModal: function() {
      this.$nextTick (function () {
        $('#apply-job').modal('hide')
      })
    },
    getWuyouUrl: function() {
      if (!this.jobId) return
      let that = this,
          url = this.API_PREFIX +  '/api/acca/job/wuyou/' + this.jobId + '?sourcing_channel=website'
      this.$http.get(url).then(function (response) {
        console.log(response)
        if (response.data.apply_url_pc)
          that.wuyouUrl = response.data.apply_url_pc
          //window.open(that.wuyouUrl, "_blank")
          window.location.assign(that.wuyouUrl)
      }).catch(function (error) {
        console.log(error)
      });
    },
    getGenericUrl: function() {
      if (!this.jobId) return
      let that = this,
          url = this.API_PREFIX +  '/api/acca/job/generic/' + this.jobId + '?sourcing_channel=website'
      this.$http.get(url).then(function (response) {
        console.log(response)
        if (response.data.apply_url_pc)
          that.genericUrl = response.data.apply_url_pc
          //window.open(that.genericUrl, "_blank")
          window.location.assign(that.genericUrl)
      }).catch(function (error) {
        console.log(error)
      });
    },
    getMagexUrl: function() {
      if (!this.jobId) return
      let that = this,
          url = this.API_PREFIX +  '/api/acca/job/magex/' + this.jobId + '?sourcing_channel=website'
      this.$http.get(url).then(function (response) {
        console.log(response)
        if (response.data.apply_url)
          that.magexUrl = response.data.apply_url
          //window.open(that.magexUrl, "_blank")
          window.location.assign(that.magexUrl)
      }).catch(function (error) {
        console.log(error)
      });
    },
    getExternalUrl: function() {
      if (!this.jobId) return
      let that = this,
          url = this.API_PREFIX +  '/api/acca/job/external/' + this.jobId
      this.$http.get(url).then(function (response) {
        if (response.data.apply_url) {
          var raw = (response.data.apply_url || '').trim()
          var absolute = raw
          if (raw) {
            if (raw.indexOf('//') === 0) {
              absolute = window.location.protocol + raw
            } else if (/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(raw)) {
              absolute = raw
            } else if (/^(www\.|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:\d+)?(\/.*)?$/.test(raw)) {
              absolute = 'https://' + raw
            } else {
              try {
                absolute = new URL(raw, window.location.href).toString()
              } catch (e) {
                absolute = raw
              }
            }
          }
          that.externalUrl = absolute
          window.location.assign(absolute)
        }
      }).catch(function (error) {
        console.log(error)
      });
    }
  }
}
</script>
